import { onDocumentLoaded } from '@theme/utilities';
import {
  getScrollEventTarget,
} from '@theme/scroll-container';

onDocumentLoaded(() => {
    const parallaxElement = [...document.querySelectorAll('[data-parallax-component]')];
    const scrollElement = getScrollEventTarget();
    if(scrollElement){
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const { target } = entry
                    if (!(target instanceof HTMLElement)) return;
                    if (entry.isIntersecting) {
                        scrollElement.addEventListener('scroll', () => handleScroll(target), { passive: true });
                    } else {
                        scrollElement.removeEventListener('scroll', () => handleScroll(target));
                    }
                });
            },
            { threshold: 0 }
        ); // Triggers as soon as the top enters or bottom leaves
        
        // Start observing each container
        parallaxElement.forEach((component) => {
            const container = component.closest('.section');
            if(container){
                observer.observe(container)
            }
        });
    }
    
    /**
     * @param {HTMLElement} container
     */
    
    function handleScroll(container) {
        const rect = container.getBoundingClientRect();
        const viewHeight = window.innerHeight;

        // Check if the parent is currently inside the viewport
        if (rect.top < viewHeight && rect.bottom > 0) {
        // Calculate how far the parent has traveled through the viewport (0 to 1)
        const totalDistance = viewHeight + rect.height;
        const traveled = viewHeight - rect.top;
        const scrollPercent = Math.min(Math.max(traveled / totalDistance, 0), 1);

        // Select the moving child element
        const child = container.querySelector('[data-parallax-component]');
        if (child instanceof HTMLElement) {
            // Adjust the multiplier (-100, -150, etc.) to control the speed and distance
            const moveAmount = scrollPercent * 800;
            const childRect = child.getBoundingClientRect();
            if(moveAmount < childRect.height){
                child.style.transform = `translateY(-${moveAmount}px)`;
            }
        }
        }
    }
});
